// src/pages/Testimonies.js
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { GlobalContext } from '../contexts/GlobalContext';
import './PastorMessages.css';

function Testimonies() {
  const [testimonies, setTestimonies] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const { resultsPerPage, setResultsPerPage } = useContext(GlobalContext);

  useEffect(() => {
    fetchMessages(currentPage, resultsPerPage);
  }, [currentPage, resultsPerPage]);

  const fetchMessages = async (page, limit) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/getTestimonies?page=${page}&limit=${limit}`
      );
      const data = await response.json();
      setTestimonies(data.testimonies);
      setTotalPages(data.totalPages);
      setCurrentPage(data.currentPage);
    } catch (error) {
      console.error('Error fetching testimonies:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-content">
      <h2>見證分享</h2>
      <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            resultsPerPage={resultsPerPage}
            setResultsPerPage={setResultsPerPage}
        />
      {isLoading ? (
        <p>載入中...</p>
      ) : testimonies.length > 0 ? (
        <ul className="messages-list">
          {testimonies.map((testimonies) => (
            <li key={testimonies.submission_id}>
              <Link to={`/testimonies/read/${testimonies.submission_id}`} title={testimonies.title}>
                <h3>{new Date(testimonies.date).toLocaleDateString()} - {testimonies.title}</h3>
                縮文：{testimonies.summary}
              </Link>
              <hr />
            </li>
          ))}
        </ul>
      ) : (
        <p>目前沒有見證分享。</p>
      )}
      {/* Pagination Buttons (Bottom) */}
      <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            resultsPerPage={resultsPerPage}
            setResultsPerPage={setResultsPerPage}
        />
    </div>
  );
}

export default Testimonies;
